// AUTO-GENERATED from Firestore dump. Do not edit by hand.
// Source: scripts/build-static-config.mjs (config version 23)

import type { TvmFormDefinition } from "../types";

const form: TvmFormDefinition = {
	"formula": {
		"totalForceNoNozzle": "(mainPower * usePercentage/100) * (11 - (0.7 * speed))",
		"cableStrainNozzle": "((((mainPower * usePercentage/100) * (11 - (0.7 * speed))) * 1.25) / 2.3) * 2",
		"totalForceNozzle": "((mainPower * usePercentage/100) * (11 - (0.7 * speed))) * 1.25",
		"cableStrainNoNozzle": "(((mainPower * usePercentage/100) * (11 - (0.7 * speed))) / 2.3) * 2"
	},
	"fields": {
		"speed": {
			"name": "speed",
			"value": 0,
			"label": "$form_propulsion_trawl_speed",
			"index": 2,
			"type": "INPUT",
			"inputType": "number"
		},
		"nozzleOptions": {
			"type": "SELECT",
			"index": 3,
			"label": "$form_propulsion_nozzle",
			"inputType": "select",
			"value": "0",
			"name": "nozzleOptions",
			"selectOptions": [
				{
					"key": 1,
					"label": "$form_propulsion_with_nozzle"
				},
				{
					"key": "0",
					"label": "$form_propulsion_without_nozzle"
				}
			]
		},
		"usePercentage": {
			"inputType": "number",
			"index": 1,
			"label": "$form_propulsion_use_percentage",
			"type": "INPUT",
			"name": "usePercentage",
			"value": 0
		},
		"mainPower": {
			"value": 0,
			"name": "mainPower",
			"inputType": "number",
			"type": "INPUT",
			"label": "$form_propulsion_main_power",
			"index": 0
		}
	},
	"hints": {
		"htmlDef": "<div style=\"font-size: 22px; font-family: Helvetica;\">     <p>{{form_propulsion_hints_p1}}</p>     <br>          <p><strong>{{form_propulsion_hints_p2}}</strong></p>     <br>      <ol>         <li>{{form_propulsion_hints_p3}}</li>         <li>{{form_propulsion_hints_p4}}</li>         <li>{{form_propulsion_hints_p5}}</li>         <li>{{form_propulsion_hints_p6}}</li>         <li>{{form_propulsion_hints_p7}}</li>         <li>{{form_propulsion_hints_p8}}</li>     </ol>      </div>",
		"title": "$form_propulsion_hints_title"
	},
	"flags": {
		"nozzle": {
			"expression": "nozzleOptions==1",
			"defValue": true
		}
	}
};

export const propulsion = form;
